import * as types from './types';

export const bookingToursMutations = {
  [types.GET_BOOKING_TOURS](state, payload) {
    state.bookingTours = payload;
  },
  
}